import {
  useCallback, useMemo,
} from 'react';
import {
  decideColorBasedOnMapTheme, isBaseMapThemeDark,
} from './mapSettingsMapStyles.helpers';
import { useMapBaseMapStylesSelector } from './mapSettingsMapStyles.selectors';

export const useCurrentBaseMapStyleColoring = () => {
  const mapStylesState = useMapBaseMapStylesSelector();

  const isDarkMapTheme = useMemo(() => (
    isBaseMapThemeDark(mapStylesState.theme)
  ), [mapStylesState.theme]);

  const getColorBasedOnMapTheme = useCallback(<T>(lightColor: T, darkColor: T) => {
    return decideColorBasedOnMapTheme(lightColor, darkColor, mapStylesState.theme);
  }, [mapStylesState.theme]);

  return {
    getColorBasedOnMapTheme,
    isDarkMapTheme,
  };
};
